import { ActivatedRoute } from '@angular/router';

import { ContainerModes } from '®shared/container-structure/common/container-mode.constant';
import { CurrentUserAndPermissions } from '®shared/current-user';
import { ReadingListDetails } from '®shared/reading-list';

export type ListRouteData = {
  containerMode?: ContainerModes;
  currentUser: CurrentUserAndPermissions;
  isDraft?: boolean;
  readingListDetails: ReadingListDetails;
};

export function getListIdFromList(route: ActivatedRoute): string {
  return route.snapshot.data.readingListDetails.id;
}
